import { IncomingMessageType, } from './incommingMessages.types';
import { CropRatio, FileSource, MediaImageStudioMode, AutoEnhanceVersion, ImageSource, TransformationKind, } from './commonTypes';
export { IncomingMessageType, };
export { POST_MESSAGE_TYPES, } from './outcomingMessages.types';
export { TransformationKind, CropRatio, FileSource, MediaImageStudioMode, AutoEnhanceVersion, ImageSource, };
export var SaveStrategy;
(function (SaveStrategy) {
    SaveStrategy["Default"] = "default";
    SaveStrategy["Upload"] = "upload";
})(SaveStrategy || (SaveStrategy = {}));
export var SegmentationType;
(function (SegmentationType) {
    SegmentationType["Portrait"] = "Portrait";
    SegmentationType["Object"] = "Object";
    SegmentationType["Logo"] = "Logo";
    SegmentationType["None"] = "None";
})(SegmentationType || (SegmentationType = {}));
export var Orientation;
(function (Orientation) {
    Orientation["Horizontal"] = "horizontal_orientation";
    Orientation["Vertical"] = "vertical_orientation";
})(Orientation || (Orientation = {}));
export var allowedLocales = [
    'cs',
    'da',
    'de',
    'en',
    'es',
    'fi',
    'fr',
    'hi',
    'it',
    'ja',
    'ko',
    'nl',
    'no',
    'pl',
    'pt',
    'ru',
    'uk',
    'sv',
    'th',
    'tr',
    'zh',
];
export var localesToFix = {
    no: 'nb',
};
//# sourceMappingURL=index.js.map